import React from 'react';

import { neptuneUrls } from '@neptune/shared/common-domain';
import { bemBlock, Icon, Link, SimpleTooltip, Text } from '@neptune/shared/venus-ui';

import './RegExpTooltip.less';

interface RegExpTooltipIconProps {
  message: string;
}

const block = bemBlock('regexp-tooltip');

const getTooltipContent = (message?: string) => (
  <div className={block('content')}>
    <Text>
      {message}{' '}
      <Link type="secondary" href={neptuneUrls.regexCompoundExpressions} external>
        See documentation
      </Link>
    </Text>
  </div>
);

const RegExpTooltipIcon = ({ message }: RegExpTooltipIconProps) => (
  <div className={block('icon')}>
    <SimpleTooltip content={getTooltipContent(message)}>
      <Icon size="xl" color="text-secondary" glyph="regex-dotstar-brackets" />
    </SimpleTooltip>
  </div>
);

export const SearchRegExpTooltip = () => {
  return <RegExpTooltipIcon message="Supports RE2 regex." />;
};

export const RegExpTooltip = () => {
  return (
    <SimpleTooltip content="Supports RE2 regex.">
      <Icon
        className={block('regexp')}
        data-role="regexp-tooltip-icon"
        color="text-action"
        glyph="regexp"
      />
    </SimpleTooltip>
  );
};
